var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFbIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37903 0 0 5.38764 0 12.0192C0 18.0393 4.4332 23.0213 10.207 23.8901L10.8335 23.9851V14.514H7.99858V12.5911H10.8335V10.0377C10.8335 8.46533 11.2102 7.42974 11.8338 6.78001C12.4574 6.13029 13.3789 5.8026 14.6612 5.8026C15.6866 5.8026 16.0855 5.86482 16.4648 5.91143V7.48533H15.13C14.3726 7.48533 13.7512 7.90859 13.4286 8.47235C13.1061 9.03611 13.0057 9.70923 13.0057 10.3952V12.5901H16.3455L16.0483 14.5129H13.0057V24L13.6246 23.9157C19.4805 23.1202 24 18.0981 24 12.0192C24 5.38764 18.621 0 12 0ZM12 1.09266C18.0314 1.09266 22.9091 5.97816 22.9091 12.0192C22.9091 17.3349 19.1104 21.7066 14.0966 22.6907V15.6055H16.9837L17.6175 11.4974H14.0966V10.3952C14.0966 9.82836 14.2001 9.32051 14.3746 9.01547C14.5492 8.71044 14.7174 8.57798 15.13 8.57798H17.5558V4.92228L17.0827 4.85826C16.7556 4.81392 16.0087 4.70994 14.6612 4.70994C13.1868 4.70994 11.9212 5.11223 11.0476 6.02241C10.174 6.93258 9.74254 8.28786 9.74254 10.0377V11.4985H6.90767V15.6066H9.74254V22.6566C4.80927 21.6099 1.09091 17.2773 1.09091 12.0192C1.09091 5.97816 5.9686 1.09266 12 1.09266Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbIc);
export default __webpack_public_path__ + "static/media/fb_ic.1be5671853ad52d7a6e8bf46eded8752.svg";
export { ForwardRef as ReactComponent };